import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setLevel } from '../actions';

import '../styles/Overlay.css';
import 'bootstrap/dist/css/bootstrap.min.css';


import LEVELS from '../levels';

class Overlay extends Component {

  state = {closed : ''}

  startLevel() {
    this.setState({closed: 'closed'});
    this.props.setLevel(this.props.level);
  }

  componentWillReceiveProps(props) {
    if (props.level !== this.props.level || props.failed) {
      this.setState({closed : undefined})
    }
  }

  render() {

    const overlayText = LEVELS[this.props.level] || LEVELS.default;

    const blurb        = overlayText.blurb;
    const failed_blurb = this.props.failed === false
      ? ''
      : this.props.failed; //overlayText.failed;

    if (blurb === undefined) {
      this.props.setLevel(this.props.level);
      return null;
    };

    return (
      <div className = {`overlay ${this.state.closed}`}>

        { this.props.failed && (
          <h2 className='failed'>
             <span className = 'failed_blurb'>{ failed_blurb }</span>
             <br/>
             You didn{"'"}t achieve the goal!
             <br/>
             Try again!
          </h2>
        )}

        <h1>Level { this.props.level }</h1>

        <div className='blurb'>{ blurb }</div>

        <div className='overlayGoButton'>
          <button
            className = 'btn btn-primary btn-lg btn-block'
            onClick={ () => this.startLevel() }>BEGIN</button>
        </div>
      </div>
    )
  }
}

Overlay.defaultProps = {
  level : 1,
}


export default connect(null, {setLevel})(Overlay);



// WEBPACK FOOTER //
// ./src/components/Overlay.js